/* eslint-disable  */

// ** Icons Import
import {
  Mail,
  MessageSquare,
  CheckSquare,
  Calendar,
  FileText,
  Circle,
  ShoppingCart,
  User,
  Shield,
  Square,
  Box,
  DollarSign,
  Percent,
  Star,
  Map,
  Layout,
  Slash,
} from "react-feather";

export default [
  {
    header: "Apps & Pages",
  },

  {
    id: "Create Invoice",
    title: "Get a Quote",
    icon: <FileText size={20} />,
    navLink: "/apps/invoiceCreate",
  },
  {
    id: "order",
    title: "Order",
    icon: <ShoppingCart size={20} />,
    children: [
      {
        id: "list",
        title: "List",
        icon: <Circle />,
        navLink: "/apps/order/list",
      },
      {
        id: "salesPiplineList",
        title: "Sales Pipeline",
        icon: <Circle />,
        navLink: "/apps/order/salesPipline/list",
      },
    ],
  },

  {
    id: "labels",
    title: "Labels",
    icon: <Square size={12} />,
    navLink: "/apps/labels/list",
  },

  {
    id: "location",
    title: "Location",
    icon: <Map />,
    children: [
      {
        id: "depot",
        title: "Depot",
        icon: <Circle />,
        navLink: "/apps/depot/list",
      },
      {
        id: "state",
        title: "State Tax",
        icon: <Circle />,
        navLink: "/apps/state/list",
      },
    ],
  },
  {
    id: "inventory",
    title: "inventory",
    icon: <Layout />,
    navLink: "/apps/inventoryFolder/list",
  },

  {
    id: "users",
    title: "User",
    icon: <User size={20} />,
    children: [
      {
        id: "all",
        title: "All",
        icon: <Circle size={12} />,
        navLink: "/apps/user/list",
      },
      {
        id: "deletedUser",
        title: "Deleted Users",
        icon: <Circle size={12} />,
        navLink: "/apps/user/deleted/list",
      },

      {
        id: "saleManager",
        title: "Sale Agent",
        icon: <Circle />,
        navLink: "/apps/saleManagerManagement/list",
      },
    ],
  },
  {
    id: "containers",
    title: "Containers",
    icon: <Box size={20} />,
    navLink: "/apps/container/list",
  },
  {
    id: "commission",
    title: "Commission",
    icon: <Percent />,
    children: [
      {
        id: "commissions",
        title: "Commissions",
        icon: <Circle />,
        navLink: "/apps/commissions/list",
      },
      {
        id: "commissionsByRole",
        title: "By Role",
        icon: <Circle />,
        navLink: "/apps/commissionsByRole/list",
      },
      {
        id: "commissionsByUser",
        title: "By User",
        icon: <Circle />,
        navLink: "/apps/commissionsByUser/list",
      },
    ],
  },
  {
    id: "discount",
    title: "Discount",
    icon: <DollarSign />,
    navLink: "/apps/discount/list",
  },
  {
    id: "blackList",
    title: "BlackList",
    icon: <Slash size={14} className="me-50" />,
    navLink: "/apps/blackList/list",
  },
  {
    id: "vendor",
    title: "Vendor",
    icon: <DollarSign />,
    navLink: "/apps/vendor/list",
  },
  {
    id: "Ranking",
    title: "Ranking",
    icon: <Star />,
    children: [
      {
        id: "rankingAgent",
        title: "Agent's Ranking",
        icon: <Circle />,
        navLink: "/apps/rankingAgent/list",
      },
      {
        id: "rankingAssistant",
        title: "Assistant's Ranking",
        icon: <Circle />,
        navLink: "/apps/rankingAssistant/list",
      },
    ],
  },
  {
    id: "email",
    title: "Email",
    icon: <Mail />,
    children: [
      {
        id: "setting",
        title: "Setting",
        icon: <Circle />,
        navLink: "/apps/email/setting/list",
      },
      {
        id: "emailStatic",
        title: "Email Static",
        icon: <Circle />,
        navLink: "/apps/email/static/list",
      },
      {
        id: "emailTemplete",
        title: "Email Templete",
        icon: <Circle />,
        navLink: "/apps/email/templete/list",
      },
    ],
  },
];
